import Home from "@/components/pages/Home";
import AboutUs from "@/components/pages/AboutUs";
import Services from "@/components/pages/Services";
import ContactUs from "@/components/pages/ContactUs";
import PastProjects from "@/components/pages/PastProjects";
import TermsOfUse from "@/components/pages/TermsOfUse";
import PrivacyAndCookiePolicy from "@/components/pages/PrivacyAndCookiePolicy";

export default [
  {
    path: "/about-us/",
    name: "AboutUS",
    component: AboutUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/services/",
    name: "Services",
    component: Services,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/contact-us/",
    name: "ContactUs",
    component: ContactUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/past-projects/",
    name: "PastProjects",
    component: PastProjects,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/privacy-and-cookie-policy/",
    name: "PrivacyAndCookiePolicy",
    component: PrivacyAndCookiePolicy,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/terms-of-use/",
    name: "TermsOfUse",
    component: TermsOfUse,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/",
    name: "Home",
    component: Home
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js